import { IMunicipio, IReqMunicipioContrato } from '../../../pages/PlanoDeGoverno/interfaces';

class PlanoGovernoMapper {

    toDomain(municipio: IReqMunicipioContrato): IMunicipio {
        return {
            id: municipio.id,
            nome: municipio.nome,
            estado: municipio.uf,
            uuid: municipio.uuid,
            idIbge: municipio.id,
        }
    }

}

// eslint-disable-next-line import/no-anonymous-default-export
export default new PlanoGovernoMapper();
